var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex align-items-center" }, [
    _c(
      "div",
      { staticClass: "flex-grow-1" },
      [
        _vm.withBack
          ? _c("Button", {
              attrs: { text: "Zurück", secondary: "", smaller: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("back")
                }
              }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _vm.withContinue
      ? _c(
          "div",
          [
            _c("Button", {
              staticClass: "mt-3",
              attrs: {
                text: _vm.continueText,
                icon: "checkmark",
                disabled: _vm.continueDisabled,
                loading: _vm.continueLoading
              },
              on: {
                click: function($event) {
                  return _vm.$emit("continue")
                }
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }